import { render, staticRenderFns } from "./TxnList.vue?vue&type=template&id=04614968"
import script from "./TxnList.vue?vue&type=script&lang=js"
export * from "./TxnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports